import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";

class CartOrderAPI {

  addProductToCart = async (data) => {
    let result = await Request.post(HOST + "/cart/addProduct", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  removeProductFromCart = async (data) => {
    let result = await Request.post(HOST + "/cart/removeProduct", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  changeAmountInCart = async (data) => {
    let result = await Request.post(HOST + "/cart/changeAmount", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };
  
  cartDetail = async (data) => {
    let result = await Request.get(HOST + "/cart/detail", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  createOrder = async (data) => {
    let result = await Request.post(HOST + "/order/create", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  myOrder = async (data) => {
    let result = await Request.post(HOST + "/order/myOrder", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  deleteOrder = async (id) => {
    let result = await Request.post(HOST + "/order/delete", { id });
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  adminList = async (data) => {
    let result = await Request.post(HOST + "/order/adminList", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  changeStatus = async (data) => {
    let result = await Request.post(HOST + "/order/changeStatus", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  orderDetail = async (data) => {
    let result = await Request.post(HOST + "/order/detail", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }
}

export default new CartOrderAPI();



// WEBPACK FOOTER //
// ./src/services/cartOrder/CartOrder.API.js